import { PaymentRequestsPage } from './PaymentRequestsPage';

export default PaymentRequestsPage;
